import { ProductFormData } from '@/@types/Products'
import { Input } from '@/components/shared/Input/Input'
import { PhoneInput } from '@/components/shared/PhoneInput/PhoneInput'
import { Button } from '@/components/ui/button'
import {
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface Step3Props {
  register: UseFormRegister<ProductFormData>
  errors: FieldErrors<ProductFormData>
  setValue: UseFormSetValue<ProductFormData>
  watch: UseFormWatch<ProductFormData>
  handleBack: () => void
  handleNext: () => void
  isCheckingSupportEmail?: boolean
}

export default function Step3({
  register,
  errors,
  setValue,
  watch,
  handleBack,
  handleNext,
  isCheckingSupportEmail = false,
}: Step3Props) {
  const { t } = useTranslation(['common', 'onboarding'])

  const whatsappSupport = watch('whatsapp_support')
  const phonePrefix = watch('phone_prefix')

  const handlePhoneChange = (value: string, prefix: string) => {
    setValue('whatsapp_support', value)
    setValue('phone_prefix', prefix)
  }

  return (
    <div className="w-full max-w-lg">
      <h1 className="text-2xl font-bold text-center mb-6">
        {t('step3Title')}
        <p className="text-interactive">
          {t('get_in_touch')}{' '}
          <strong className="text-white font-normal">?</strong>{' '}
        </p>
      </h1>

      <form className="space-y-6">
        <div>
          <Input
            {...register('email_support')}
            label={t('supportEmailLabel')}
            placeholder={t('supportEmailPlaceholder')}
            helperText={errors?.email_support?.message}
            data-cy="support-email"
          />
        </div>
        <PhoneInput
          label={t('supportWhatsAppLabel')}
          onChangePhone={(value, prefix) => handlePhoneChange(value, prefix)}
          phone_prefix={phonePrefix}
          value={whatsappSupport}
          placeholder={t('supportWhatsAppPlaceholder')}
          helperText={errors?.whatsapp_support?.message}
          data-cy="support-whatsapp"
        />

        <div className="flex justify-center gap-6 mt-8">
          <Button type="button" onClick={handleBack} variant="ghost">
            {t('back')}
          </Button>
          <Button
            data-cy="next"
            type="button"
            onClick={handleNext}
            variant="default"
            disabled={isCheckingSupportEmail}
          >
            {t('next')}
          </Button>
        </div>
      </form>
    </div>
  )
}
